module.exports = {
  "rain-item": {
    "position": "absolute",
    "opacity": 0
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-d2396878!./~/weex-vue-loader/lib/selector.js?type=styles&index=0!./packages/wxc-lottery-rain/rain-item.vue
// module id = 195
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34